// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"77":"cosmo","146":"spacelab","159":"yeti","340":"berulean","359":"readable","445":"journal","603":"simplex","625":"flatly","647":"wetterau","712":"shared","762":"united","794":"cerulean"}[chunkId] + ".chunk.js";
};